import { MDBBtn, MDBCol, MDBContainer, MDBRow, } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useDarkMode } from "../../components/assets/DarkModeContext";
import { useCurrentUser } from "../../components/hooks/useCurrentUser";
import OriginalResumePdfPreview from "../../components/resume-list/OriginalResumePdfPreview";
import ResumeList from "../../components/resume-list/ResumeList";
import { getUserWithResumesById, } from "../../components/services/httpService";
import { Evaluation } from "../../components/user/Evaluation";
import Information from "../../components/user/Information";
import { formatPrenom } from "../../utils/formatPrenom";

export default function UserResumes() {
    const { userId } = useParams();
    const currentUser = useCurrentUser();
    const [user, setUser] = useState({ nom: "", role: "", email: "", docUrl: "" });
    const [userResumes, setUserResumes] = useState([]);

    const [activeTab, setActiveTab] = useState("Mes CVS");
    const { isDarkMode } = useDarkMode();

    useEffect(() => {
        getUserWithResumesById(userId)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                const { resumes, ...userData } = data;
                setUser(userData);

                if (Array.isArray(resumes)) {
                    setUserResumes(resumes);
                } else {
                    console.error("Data received is not an array", resumes);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, [userId]);

    const sortedResumes = [...userResumes].sort((a, b) => {
        const dateA = a.lastModificationDate
            ? new Date(a.lastModificationDate)
            : new Date(0);
        const dateB = b.lastModificationDate
            ? new Date(b.lastModificationDate)
            : new Date(0);

        return dateB - dateA;
    });

    const containerClass = isDarkMode ? "bg-dark-mode" : "bg-light";
    const titleClass = isDarkMode ? "text-white" : "text-muted";
    const buttonClass = isDarkMode ? "text-white bg-dark-mode" : "";

    const refresh = () => {
        getUserWithResumesById(userId)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                const { resumes, ...userData } = data;
                setUser(userData);

                if (Array.isArray(resumes)) {
                    setUserResumes(resumes);
                } else {
                    console.error("Data received is not an array", resumes);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    return (
        <MDBContainer fluid className={containerClass}>
            <MDBContainer className="pb-5">
                <section className="text-center text-md-start bg-nav animation-fade-in">
                    <div
                        className="p-5 bg-image"
                        style={{
                            height: "300px",
                            backgroundImage: 'url("/bg/bg-mon-compte.png")',
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            backgroundAttachment: "fixed",
                        }}
                    ></div>
                    <div
                        className="pb-2"
                        style={{ backgroundColor: "background-color: hsl(0, 0%, 98%)" }}
                    >
                        <MDBContainer>
                            <MDBRow className="d-flex justify-content-center align-items-center">
                                <MDBCol lg="8" md="8" className="mb-4 mb-md-0 pt-4">
                                    <img
                                        src="./spinner-alcyone.png"
                                        className="rounded-circle float-none float-md-start me-4 mb-3 bg-white"
                                        alt=""
                                        style={{
                                            width: "168px",
                                            marginTop: "-110px",
                                            border: "4px solid hsl(0, 0%, 98%)",
                                            position: "relative",
                                            zIndex: 1000,
                                        }}
                                    />
                                    {user && (
                                        <>
                                            <h1 className={titleClass}>
                                                {user?.prenom ? formatPrenom(user.prenom) : ""}{" "}
                                                <span className="text-uppercase">
                                                    {user?.nom ? user.nom : ""}
                                                </span>
                                            </h1>
                                            <h2 className={titleClass}
                                                style={{ color: "#09B4BF" }}
                                            >{user.role === "SUPERADMIN" ? "SUPER ADMIN" : user.role}</h2>
                                        </>
                                    )}
                                </MDBCol>
                                <MDBCol
                                    lg="4"
                                    md="8"
                                    className="mb-4 mb-md-0 text-center text-lg-end"
                                ></MDBCol>
                            </MDBRow>
                        </MDBContainer>
                    </div>
                </section>

                <MDBContainer className="mb-5">
                    <div>
                        <ul
                            className="nav nav-tabs mb-5 justify-content-center"
                            id="issuesTabs"
                        >
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "Mes CVS" ? "active" : ""} ${buttonClass}`}
                                    id="tab-2"
                                    onClick={() => setActiveTab("Mes CVS")}
                                >
                                    Liste des CVs
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "cvOrigine" ? "active" : ""
                                        } ${buttonClass}`}
                                    id="tab-2"
                                    onClick={() => setActiveTab("cvOrigine")}
                                >
                                    CV d'origine
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "Evaluation" ? "active" : ""
                                        } ${buttonClass}`}
                                    id="tab-1"
                                    onClick={() => setActiveTab("Evaluation")}
                                >
                                    Evaluation des performances
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "Information" ? "active" : ""
                                        } ${buttonClass}`}
                                    id="tab-1"
                                    onClick={() => setActiveTab("Information")}
                                >
                                    Mes Informations
                                </button>
                            </li>
                        </ul>
                    </div>
                    {activeTab === "Mes CVS" && (
                        <ResumeList
                            title={`${user?.prenom ? formatPrenom(user.prenom) + "'s " : ""} CVs`}
                            resumes={sortedResumes}
                            user={user}
                            refresh={refresh}
                        >
                            <div className="d-flex text-center justify-content-center align-items-center">
                                <Link to="/envoyer-message">
                                    <MDBBtn className="BtnCard">Envoyer un message</MDBBtn>
                                </Link>
                            </div>
                        </ResumeList>
                    )}
                    {activeTab === "cvOrigine" && (
                        <OriginalResumePdfPreview
                            currentUser={currentUser}
                            user={user}
                        />
                    )}
                    {activeTab === "Evaluation" && (
                        <Evaluation />
                    )}
                    {activeTab === "Information" && (
                        <Information userData={user} authenticatedUserRole={currentUser.role} />
                    )}
                </MDBContainer>
            </MDBContainer>
        </MDBContainer>
    );
}
